export default __webpack_public_path__ + "content/media/6.1dad5df5.jpg";